<template>
  <div class="headerTop">
    <a href="http://www.chinaacc.com"
        target="_blank">正保会计网校</a>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: "CommonNewHeader",
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  }
</script>
<style lang="scss" scoped>
.headerTop {
  width: 100%;
  height: 72px;
  background: url(~@/assets/images/entry/title.jpg) no-repeat top left;
  a {
    position: absolute;
    width: 143px;
    height: 39px;
    left: 15px;
    top: 14px;
    text-indent: -999em;
    overflow: hidden;
  }
  .right {
    float: right;
  }
}
</style>
